module.exports = __webpack_public_path__ + "static/media/mobile_patient_passport@2x.edb77800.png";